module.exports = __webpack_public_path__ + "static/media/AudienceGraphic-es.0b3b4a28.jpg";